import { useEffect, useState } from 'react'
import { PageHeader } from '@/components/layout/PageHeader'
import { useAppAuth } from '@/contexts/app-auth.context'
import { UserSecurity } from '@workos-inc/widgets/user-security'

export function UserSecurityPage() {
  const { getAccessToken } = useAppAuth()
  const [accessToken, setAccessToken] = useState<string | null>(null)

  useEffect(() => {
    const fetchToken = async () => {
      const token = await getAccessToken()
      setAccessToken(token)
    }
    fetchToken()
  }, [getAccessToken])

  return (
    <div className="h-full overflow-y-auto mt-16">
      <div className="space-y-6 p-6 pt-0 mt-6">
        <PageHeader title="Manage your security settings including password and MFA" />

        <div className="bg-card">
          {accessToken ? (
            <UserSecurity authToken={accessToken} />
          ) : (
            <div className="p-6">
              <div className="text-center">
                <p className="text-muted-foreground">Loading...</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
